import {createAction} from "@reduxjs/toolkit";
import Rain from "src/models/Rain";

const RainActions = {
    SET_RAINS_LIST: createAction<Rain[]>('SET_RAINS_LIST'),
    CLEAR_RAINS: createAction<void>('CLEAR_RAINS'),
}

export default RainActions;
